angular.module('qkr').factory('couponService', ($http, appConfig, $q, $uibModal, $rootScope,
                                                $routeParams, $timeout, utils, merchantService, outletService,
                                                inventoryService, gettextCatalog, $log) => {
    const getMerchant = function() {
        const deferred = $q.defer();

        if ($rootScope.merchantInfo != null) {
            deferred.resolve($rootScope.merchantInfo);
        } else {
            merchantService.refreshMerchantInfo().then((merchantInfo) => {
                deferred.resolve(merchantInfo);
            });
        }

        return deferred.promise;
    };

    const getCouponList = function(offset, max, outletId, couponFilter) {
        const getCouponListCommand = {
            offset: offset || 0,
            max: max || 10,
            outletId: outletId,
            couponFilter: couponFilter || "Active"
        };

        return $http.post(appConfig.apiUrl + 'coupon/getCouponList', getCouponListCommand, {withCredentials: true})
            .then((response) => response.data);
    };

    const getProductList = function(isEdit, couponPromise) {
        const deferred = $q.defer();
        const ret = {};

        if (isEdit) {
            $q.all([couponPromise]).then((responses) => {
                // Set products in ret and set selectedProducts using couponPromise
                const coupon = responses[0];
                const variantIds = [];

                angular.forEach(coupon.variants, (variant) => {
                    variantIds.push({value: variant.id});
                });

                inventoryService.getCategoriesforSelectedVariants(variantIds).then((response) => {
                    const categoriesForVariants = [];
                    angular.forEach(response.data, (cat) => {
                        categoriesForVariants.push({value: cat.id});
                    });

                    inventoryService.getProductsForSelectedCategories(categoriesForVariants).then((responseProds) => {
                        ret.selectedProducts = [];
                        ret.products = responseProds.data;
                        coupon.variants.forEach(variant => {
                            ret.products.forEach(product => {
                                product.variants.forEach(prodVariant => {
                                    if (variant.id === prodVariant.id && ret.selectedProducts.indexOf(product) === -1) {
                                        ret.selectedProducts.push(product);
                                    }
                                });
                            });
                        });
                        deferred.resolve(ret);
                    });
                });
            });
        } else {
            ret.products = [];
            ret.selectedProducts = [];
            deferred.resolve(ret);
        }

        return deferred.promise;
    };

    var setUpCouponFields = function(coupons, merchantInfo) {
        const couponTypes = [
            'COUPON_AMOUNT_OFF_BASKET',
            'COUPON_PERCENT_OFF_BASKET'
        ];
        const couponTypeStrs = [gettextCatalog.getString('Amount off cart'),
                                gettextCatalog.getString('Percent off cart')];

        angular.forEach(coupons, (coupon) => {
            // Set displayStatus
            if (coupon.displayStatus.indexOf('Expired') !== -1) {
                coupon.displayStatus = 'Expired';
            } else if (coupon.isDraft) {
                coupon.displayStatus = 'Draft';
            } else if (coupon.deactivated) {
                coupon.displayStatus = 'Inactive';
            } else if (coupon.startDate > new Date()) {
                coupon.displayStatus = 'Start';
            } else {
                coupon.displayStatus = 'Active';
            }

            // Used percentages
            if (coupon.timesUsed === 0 && coupon.timesScanned === 0) {
                coupon.usedPercentage = 0;
            } else {
                coupon.usedPercentage = (coupon.timesUsed / coupon.timesScanned) * 100;
                coupon.usedPercentage = coupon.usedPercentage.toFixed(0);
            }

            if (coupon.aquireMechanism === undefined || coupon.aquireMechanism === 'QRCODE') {
                coupon.showQr = true;
            }

            // Merchant level coupons aren't editable at outlet level, unless merchant is a school/university
            if (!coupon.outletLevel && appConfig.outletLevel
                && !merchantService.behaviour(merchantInfo, 'couponPage.deptBasedCoupon')) {
                coupon.isEditable = false;
            } else if (coupon.mastercardFunded && appConfig.isMCAdmin) {
                coupon.isEditable = false;
            } else {
                coupon.isEditable = true;
            }

            // Set the type to be a string
            coupon.typeStr = couponTypeStrs[couponTypes.indexOf(coupon.type)];
        });

        return coupons;
    };

    const listNoOutlets = function() {
        // For listing screen on outlet level, don't need to get outlet list but need to return a promise,
        // can just return promise with empty list
        const deferred = $q.defer();

        $timeout(() => {
            deferred.resolve([]);
        }, 300);

        return deferred.promise;
    };

    const setupLocations = function(locations, couponPromise, deptBasedCoupon, merchantInfo) {
        const deferred = $q.defer();

        couponPromise.then((coupon) => {
            const result = {};
            const supplyCoupon = merchantService.behaviour(merchantInfo, 'couponPage.supplyCoupon');
            result.showLocations = true;
            result.locations = locations;

            if (locations.length <= 1) {
                result.showLocations = false;
            } else if ((coupon.outletLevel || appConfig.outletLevel) && !deptBasedCoupon && !supplyCoupon) {
                result.showLocations = false;
            }

            if (coupon.applicableLocations.length === 0) {
                // If no applicableLocations are specified then treat as all are selected
                for (var j = 0; j < result.locations.length; ++j) {
                    if (!(result.locations[j].sharedWith && !supplyCoupon)) {
                        result.locations[j].selected = true;
                        coupon.applicableLocations.push({id: result.locations[j].id});
                    }
                }
            } else {
                // Otherwise set the selected flag for the locations selected
                for (let i = 0; i < coupon.applicableLocations.length; ++i) {
                    const applicableLocation = coupon.applicableLocations[i];
                    for (var j = 0; j < result.locations.length; ++j) {
                        const loc = result.locations[j];
                        if (loc.id === applicableLocation.id) {
                            loc.selected = true;
                            break;
                        }
                    }
                }
            }

            deferred.resolve(result);
        });

        return deferred.promise;
    };

    const getCommonConfig = function(merchantInfoPromise, couponPromise, isEdit) {
        const deferred = $q.defer();

        $q.all([merchantInfoPromise, couponPromise]).then((results) => {
            const result = {};

            result.isEdit = isEdit;
            result.couponOutletLevel = results[1].outletLevel;
            result.deptBasedCoupon = merchantService.behaviour(results[0], 'couponPage.deptBasedCoupon');
            result.supplyCoupon = merchantService.behaviour(results[0], 'couponPage.supplyCoupon');
            result.outletLevel = appConfig.outletLevel;
            result.privileged = appConfig.isMCAdmin;
            result.readOnly = results[1].mastercardFunded && !result.privileged && result.isEdit;
            result.canEdit = true;
            // Can't edit a coupon at the outlet level if it's been created at merchant level,
            // if at merchant level can edit a coupon created at outlet level as it applies to only one outlet
            if (result.outletLevel && !results[1].outletLevel && !result.deptBasedCoupon
                && !result.supplyCoupon && !result.privileged) {
                result.canEdit = false;
            }
            result.currency = results[0].defaultCurrency;

            deferred.resolve(result);
        });

        return deferred.promise;
    };

    const createNewCoupon = function(merchantInfoPromise, outletInfoPromise) {
        const deferred = $q.defer();

        $q.all([merchantInfoPromise, outletInfoPromise]).then((responses) => {
            const merchantInfo = responses[0];
            const outletInfo = responses[1];
            const deptBasedCoupon = merchantService.behaviour(merchantInfo, 'couponPage.deptBasedCoupon');
            const applicableLocations = (appConfig.outletLevel && !deptBasedCoupon) ? [{id: outletInfo.id}] : [];

            deferred.resolve({
                type: '',
                expiryDate: (new Date().getTime() + 30 * 24 * 60 * 60 * 1000),
                currency: merchantInfo.defaultCurrency,
                maxDiscount: undefined,
                minCartTotal: undefined,
                phoneLayoutStyle: 2,
                applyCouponBeforeTax: true,
                singleUsePerCustomer: true,
                mastercardFunded: false,
                imageUrl: '',
                outletLevel: appConfig.outletLevel,
                aquireMechanism: 'QRCODE',
                extra: 'FULL_CART',
                thumbnailImageUrl: merchantInfo.logo,
                applicableLocations,
                variants: [],
                applyToCheapest: false,
                isDraft: false,
                unlimitedUsages: true,
                binRanges: null,
                usageLimit: null,
                usageDiscriminator: null,
                activeTimeOfDayStart: null,
                activeTimeOfDayEnd: null,
                startDate: new Date(),
                availableDaysOfWeek: null,
                hasExpiryDate: true
            });
        });

        return deferred.promise;
    };

    const getCouponMap = function(couponId, merchantInfoPromise) {
        const deferred = $q.defer();

        const couponPromise = getCoupon(couponId);

        $q.all([couponPromise, merchantInfoPromise]).then((results) => {
            const couponMap = results[0];
            couponMap.currency = results[1].defaultCurrency;

            if (couponMap.expiryDate) {
                couponMap.expiryDate = utils.serverDateStringtoDate(couponMap.expiryDateStr);
            }

            if (couponMap.startDate) {
                couponMap.startDate = utils.serverDateStringtoDate(couponMap.startDateStr);
            }

            if (couponMap.type === 'COUPON_PERCENT_OFF_BASKET' || couponMap.type === 'COUPON_AMOUNT_OFF_BASKET') {
                if (couponMap.maxDiscount !== null) {
                    couponMap.extra = 'WITH_MAX';
                } else if (couponMap.minCartTotal !== null) {
                    couponMap.extra = 'CART_OVER';
                } else {
                    couponMap.extra = 'FULL_CART';
                }
            }

            if (couponMap.binRange) {
                couponMap.binRanges = couponMap.binRange.split(',');
            }

            deferred.resolve(couponMap);
        });

        return deferred.promise;
    };

    const getCoupon = function(couponId) {
        return $http.get(appConfig.apiUrl + 'coupon/get/' + couponId, {withCredentials: true})
            .then((response) => response.data)
            .catch($log.error);
    };

    return {
        processCoupons(merchantInfo, coupons) {
            angular.forEach(coupons, (coupon) => {
                if (coupon.expiryDate) {
                    coupon.expiryDate = utils.serverDateStringtoDate(coupon.expiryDateStr);
                }

                if (coupon.startDate) {
                    coupon.startDate = utils.serverDateStringtoDate(coupon.startDateStr);
                }
            });

            return setUpCouponFields(coupons, merchantInfo);
        },
        getCouponsList(offset, max, ouletId, couponFilter) {
            return getCouponList(offset, max, ouletId, couponFilter);
        },
        getCoupon(couponId) {
            return $http.get(appConfig.apiUrl + 'coupon/get/' + couponId, {withCredentials: true})
                .then((response) => response.data)
                .catch($log.error);
        },

        getOutlet() {
            const deferred = $q.defer();

            if (appConfig.outletLevel) {
                if (!$rootScope.outletInfo) {
                    outletService.refreshOutletInfo().then(() => {
                        deferred.resolve($rootScope.outletInfo);
                    });
                } else {
                    deferred.resolve($rootScope.outletInfo);
                }
            } else {
                return deferred.resolve({});
            }

            return deferred.promise;
        },

        getLocations(merchantInfoPromise, couponPromise) {
            const deferred = $q.defer();

            const outletListPromise = outletService.listOutletsSummary();

            merchantInfoPromise.then((merchantInfo) => {
                const deptBasedCoupon = merchantService.behaviour(merchantInfo, 'couponPage.deptBasedCoupon');
                // DeptBasedCoupon = true if merchant is school/university
                const supplyCoupon = merchantService.behaviour(merchantInfo, 'couponPage.supplyCoupon');
                //SupplyCoupon = true if the merchant is a supplier


                if (deptBasedCoupon || supplyCoupon) {
                    if (!$rootScope.outletInfo) {
                        outletService.refreshOutletInfo().then(() => {
                            outletService.loadCurrentOutletDepartments().then((departments) => {
                                deferred.resolve(setupLocations(departments, couponPromise,
                                    deptBasedCoupon, merchantInfo));
                            });
                        });
                    } else {
                        outletService.loadCurrentOutletDepartments().then((departments) => {
                            deferred.resolve(setupLocations(departments, couponPromise, deptBasedCoupon, merchantInfo));
                        });
                    }
                } else {

                    outletListPromise.then((outlets) => {
                        deferred.resolve(setupLocations(outlets, couponPromise, deptBasedCoupon, merchantInfo));
                    });
                }
            });

            return deferred.promise;
        },

        createCoupon(coupon) {
            return $http.post(appConfig.apiUrl + 'coupon/create', coupon);
        },

        updateCoupon(coupon) {
            return $http.post(appConfig.apiUrl + 'coupon/update', coupon);
        },

        deleteCoupon(coupon) {
            return $http.post(appConfig.apiUrl + 'coupon/delete', {id: coupon.couponId});
        },

        deactivateCoupon(coupon) {
            return $http.post(appConfig.apiUrl + 'coupon/deactivate', {id: coupon.couponId});
        },

        reactivateCoupon(coupon) {
            return $http.post(appConfig.apiUrl + 'coupon/reactivate', {id: coupon.couponId});
        },

        openQRModal(coupon) {
            return $uibModal.open({
                template: require('../../controllers/merchant/couponQrCode.html'),
                controller: 'couponQRController',
                windowClass: 'fade',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    coupon() {
                        return coupon;
                    }
                }
            });
        },

        allowedActivate(coupon, coupons) {
            if (coupon.aquireMechanism === 'PURCHASE_REWARD') {
                // Count number of active purchase reward coupons
                let count = 0;
                for (let i = 0; i < coupons.length; i++) {
                    const c = coupons[i];
                    if (c.aquireMechanism === 'PURCHASE_REWARD' && c.displayStatus === 'Active') {
                        count++;
                    }
                }

                if (count > 0) {
                    return false; // Only allowed one active PURCHASE_REWARD coupon
                }
            }
            return true;
        },

        resolveList(outletId) {
            // OutletList if outlet level
            // CouponList
            const outletListPromise = appConfig.outletLevel ? listNoOutlets() : outletService.listOutletsSummary();
            const couponListPromise = getCouponList();

            const promiseList = [outletListPromise, couponListPromise];

            return $q.all(promiseList).then((responses) => {
                return ({
                    outlets: responses[0],
                    couponData: responses[1]
                });
            });
        },

        resolve(isEdit) {
            const merchantInfoPromise = getMerchant();
            const outletInfoPromise = this.getOutlet();
            const couponPromise = isEdit ? getCouponMap($routeParams.couponId, merchantInfoPromise)
                : createNewCoupon(merchantInfoPromise, outletInfoPromise);
            const locationsListPromise = this.getLocations(merchantInfoPromise, couponPromise);
            const commonConfigPromise = getCommonConfig(merchantInfoPromise, couponPromise, isEdit);
            const productListPromise = getProductList(isEdit, couponPromise);
            const couponListPromise = getCouponList();

            const promiseList = [merchantInfoPromise, outletInfoPromise, couponPromise,
                locationsListPromise, productListPromise, commonConfigPromise, couponListPromise];


            return $q.all(promiseList).then((responses) => ({
                merchantInfo: responses[0],
                outletInfo: responses[1],
                coupon: responses[2],
                locationConfig: responses[3],
                productConfig: responses[4],
                commonConfig: responses[5],
                coupons: responses[6]
            }));
        }

    };
})
;



// WEBPACK FOOTER //
// ./src/coupons/services/coupon.services.js